import { PropsOf } from 'types';
import connect from './connect';
import RehydrationGuard from './RehydrationGuard';

export default connect(RehydrationGuard);

export type RehydrationGuardProps = PropsOf<ReturnType<typeof connect>>;
